import { projectsApi } from '../api/projects';
import { storiesApi } from '../api/stories';
import { sessionsApi } from '../api/sessions';

/**
 * Resolves the most-recently-active project -> story -> session chain.
 * Consolidates what useStoryId, ChatPage's no-session branch, and
 * ProjectsPage.openProject each used to compute independently (F9 plan §4).
 *
 * - No args: resolves the globally most-recent project first (mirrors
 *   useStoryId / ChatPage's no-session fallback).
 * - `projectId`: scopes the story/session lookup to that project.
 * - `project`: same as `projectId`, but skips the redundant GET when the
 *   caller already has the full project record (ChatPage's no-session
 *   branch; single-book ProjectsPage.openProject lands on Discovery
 *   instead — #664).
 */
export async function resolveMostRecentContext({ projectId, project: knownProject } = {}) {
  const project = knownProject
    ?? (projectId ? await projectsApi.get(projectId) : (await projectsApi.list())[0] ?? null);
  if (!project) return { project: null, story: null, session: null };

  const stories = await storiesApi.list(project.id);
  const story = stories?.[0] ?? null;
  if (!story) return { project, story: null, session: null };

  const sessions = await sessionsApi.list(story.id);
  const session = sessions?.[0] ?? null;
  return { project, story, session };
}
